var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1485_25972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49609 12.75H9.99609V8.25H8.49609V12.75ZM9.24609 6.75C9.45859 6.75 9.63684 6.678 9.78084 6.534C9.92484 6.39 9.99659 6.212 9.99609 6C9.99559 5.788 9.92359 5.61 9.78009 5.466C9.63659 5.322 9.45859 5.25 9.24609 5.25C9.03359 5.25 8.85559 5.322 8.71209 5.466C8.56859 5.61 8.49659 5.788 8.49609 6C8.49559 6.212 8.56759 6.39025 8.71209 6.53475C8.85659 6.67925 9.03459 6.751 9.24609 6.75ZM9.24609 16.5C8.20859 16.5 7.23359 16.303 6.32109 15.909C5.4086 15.515 4.61484 14.9808 3.93984 14.3063C3.26484 13.6318 2.73059 12.838 2.33709 11.925C1.94359 11.012 1.74659 10.037 1.74609 9C1.74559 7.963 1.94259 6.988 2.33709 6.075C2.73159 5.162 3.26584 4.36825 3.93984 3.69375C4.61384 3.01925 5.4076 2.485 6.32109 2.091C7.2346 1.697 8.20959 1.5 9.24609 1.5C10.2826 1.5 11.2576 1.697 12.1711 2.091C13.0846 2.485 13.8783 3.01925 14.5523 3.69375C15.2263 4.36825 15.7608 5.162 16.1558 6.075C16.5508 6.988 16.7476 7.963 16.7461 9C16.7446 10.037 16.5476 11.012 16.1551 11.925C15.7626 12.838 15.2283 13.6318 14.5523 14.3063C13.8763 14.9808 13.0826 15.5152 12.1711 15.9097C11.2596 16.3042 10.2846 16.501 9.24609 16.5ZM9.24609 15C10.9211 15 12.3398 14.4187 13.5023 13.2562C14.6648 12.0937 15.2461 10.675 15.2461 9C15.2461 7.325 14.6648 5.90625 13.5023 4.74375C12.3398 3.58125 10.9211 3 9.24609 3C7.57109 3 6.15234 3.58125 4.98984 4.74375C3.82734 5.90625 3.24609 7.325 3.24609 9C3.24609 10.675 3.82734 12.0937 4.98984 13.2562C6.15234 14.4187 7.57109 15 9.24609 15Z",
    fill: "#E96358"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1485_25972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.ebf53f98e13e6c6eda2c11d542a2505f.svg";
export { ForwardRef as ReactComponent };